import MemberInfo from './MemberInfo.component';

export default MemberInfo;
